import { format } from "@cloudinary/base/actions/delivery"
import { fill } from "@cloudinary/base/actions/resize"
import { gif, jpg } from "@cloudinary/base/qualifiers/format"
import { focusOn } from "@cloudinary/base/qualifiers/gravity"
import { auto } from "@cloudinary/base/qualifiers/quality"
import { cloudinary } from "/src/index"

function getCloudinaryThumbnailUrl(thumbnail, size = 280) {
  return cloudinary
    .image(thumbnail.public_id)
    .resize(fill().width(size).aspectRatio("16:9").gravity(focusOn(auto())))
    .delivery(format(thumbnail.format === "jpg" ? jpg() : gif()))
    .toURL()
}

export default getCloudinaryThumbnailUrl
